module.exports = __webpack_public_path__ + "img/cmrt.16283153.png";